export default {
  Chart: 'Chart',
  Promotions: 'Акции',
  GiftRules: 'Подарки за состав',
  ApplianceRules: 'Правила приборов',
  LookUps: 'Справочники',
  Contacts: 'Контакты',
  ApplicationDescription: 'О приложении',
  Administration: 'Администрирование',
  Users: 'Пользователи',
  Actions: 'Действия',
  Name: 'Наименование',
  Reports: 'Отчеты',
  DigitalCurrency: 'Цифровые оплаты',
  OperatorReport: 'Отчёт по операторам',
  PaymentReconciliation: 'Сверка оплат',
  CustomerLoyalty: 'Бонусы клиента',
  Vacancies: 'Вакансии',
  Feedback: 'Обратная связь',
  Cities: 'Города',
  Add: 'Добавить',
  GroupCriteria: 'Группы для рассылки',
  NotificationCampaigns: 'Рассылки',
  PaymentMethod: 'Способы оплаты',
  SystemSettings: 'Настройки системы',
  NotificationSettings: 'Настройки уведомлений',
  SmsJournal: 'Журнал SMS',
  Monitoring: 'Мониторинг',
  WorkFlows: 'Workflows',
  ExchangeStorage: 'Хранение журналов',
  OrderTypes: 'Типы заказов',
  Dashboard: 'Главная',
  Roles: 'Роли',
  Customer: 'Клиенты',
  Restaurant: 'Рестораны',
  Couriers: 'Курьеры',
  Menu: 'Меню',
  OrderState: 'Состояние заказа',
  CounterParty: 'Контрагенты',
  Orders: 'Заказы',
  PaymentCallbacks: 'Приём платежей',
  WebHooks: 'Вебхуки',
  IntegrationExchanges: 'Обмен с внешними системами',
  VacancyApplication: 'Заявки на вакансию',
  ApplicationInfo: 'О приложении',
  TermsOfUse: 'Пользовательское соглашение',
  MobileApp: 'Мобильное приложение',
  WebSite: 'WEB Сайт',
  Instagram: 'Instagram',
  Facebook: 'Facebook',
  PhoneNumber: 'Телефонный номер',
  WhatsApp: 'WhatsApp',
  Android: 'Android',
  iOS: 'iOS',
  Delivery: 'Доставка',
  TakeAway: 'На вынос',
  Male: 'Мужской',
  Female: 'Женский',
  New: 'Новая',
  Rejected: 'Отказана',
  Processed: 'Обработана',
  Office: 'Офис',
  Cafe: 'Кафе',
  Manufacture: 'Производство',
  Documentation: 'Документация',
  PresentDish: 'Подарочный товар',
}
